import { initialGeneralState } from 'redux/initialState';

import generalActionTypes from './action-types';

const generalReducer = (state = initialGeneralState, { type, payload }) => {
  switch (type) {
    case generalActionTypes.SET_TEST_GENERAL:
      return {
        ...state,
        testGeneral: payload,
      };

    default:
      return state;
  }
};

export default generalReducer;
